var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { toLocalTime } from "../../../../../../../../common/helpers";
import I18nText from "../../../../../../../../components/i18n/I18nText";
import { DATE_TIME_FORMAT } from "../../../../../../../fs/reports/constants";
import { formatPriceHistory, getPriceHistoryLabel } from "../../../helper";
var CatalogueHistoryTableRow = function (_a) {
    var _b, _c;
    var item = _a.item, index = _a.index;
    var key = item.key, request = item.request, updatedAt = item.updatedAt, updatedBy = item.updatedBy;
    var formattedUpdatedAtDate = toLocalTime(updatedAt, DATE_TIME_FORMAT);
    var priceHistoryKey = (_c = (_b = Object.getOwnPropertyNames(request)) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : "";
    return (_jsxs("div", __assign({ className: "TableRow CatalogsHistoryTableRow" }, { children: [_jsx("p", { children: index + 1 }), _jsx("p", { children: _jsx(I18nText, { token: getPriceHistoryLabel(priceHistoryKey) }) }), _jsx("p", { children: formatPriceHistory(priceHistoryKey, request) }), _jsx("p", { children: formattedUpdatedAtDate }), _jsx("p", { children: updatedBy })] }), "catalogueHistoryItem-".concat(key)));
};
export default CatalogueHistoryTableRow;
